import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useMemo, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _throttle from 'lodash/throttle';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { getUpdateScrollState } from '@tekion/tekion-base/actionCreators/tableItems';
import Spinner from '../../../SpinnerComponent';
import TABLE_ACTION_TYPES from '../../../../organisms/TableManager/constants/actionTypes';
import styles from '../../table.module.scss';
var BodyComponent = function BodyComponent(_ref) {
  var children = _ref.children,
    scrollLoading = _ref.scrollLoading,
    onAction = _ref.onAction,
    loading = _ref.loading,
    totalNumberOfEntries = _ref.totalNumberOfEntries,
    minRows = _ref.minRows,
    getUpdateScrollState = _ref.getUpdateScrollState,
    itemType = _ref.itemType,
    scrollState = _ref.scrollState,
    fetchOnScrollThreshold = _ref.fetchOnScrollThreshold;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showLoadMore = _useState2[0],
    setLoadMore = _useState2[1];
  var bodyComponent = useRef(null);
  var allRowsLoaded = minRows >= totalNumberOfEntries;
  var hideLoadMore = useRef(function () {
    if (showLoadMore) {
      setLoadMore(!showLoadMore);
    }
  });
  var throttledScroll = useMemo(function () {
    return _throttle(function () {
      var _bodyComponent$curren = bodyComponent.current,
        scrollHeight = _bodyComponent$curren.scrollHeight,
        scrollTop = _bodyComponent$curren.scrollTop,
        clientHeight = _bodyComponent$curren.clientHeight;
      if ((scrollHeight === clientHeight || scrollHeight - scrollTop - clientHeight <= fetchOnScrollThreshold) && !scrollLoading && !loading && !allRowsLoaded) {
        onAction({
          type: TABLE_ACTION_TYPES.TABLE_SCROLL_FETCH
        });
        if (scrollState) {
          getUpdateScrollState(undefined, {
            itemType: itemType
          });
        }
        hideLoadMore.current();
      }
    }, 300);
  }, [children]);
  useEffect(function () {
    bodyComponent.current.addEventListener('scroll', throttledScroll);
    return function cleanup() {
      bodyComponent.current.removeEventListener('scroll', throttledScroll);
      throttledScroll.cancel();
    };
  });
  useEffect(function () {
    throttledScroll(); // Triggered on first load to see if no scroll is present;
  }, [loading]);
  useLayoutEffect(function () {
    var _ref2 = scrollState || EMPTY_OBJECT,
      scrollHeight = _ref2.scrollHeight,
      scrollTop = _ref2.scrollTop,
      clientHeight = _ref2.clientHeight;
    var _ref3 = bodyComponent.current || EMPTY_OBJECT,
      bodyScrollHeight = _ref3.scrollHeight,
      bodyScrollTop = _ref3.scrollTop,
      bodyClientHeight = _ref3.clientHeight;
    if (scrollState && scrollHeight <= bodyScrollHeight && clientHeight <= bodyClientHeight && scrollTop !== bodyScrollTop) {
      bodyComponent.current.scrollTop = scrollTop;
      hideLoadMore.current();
    }
  });
  useEffect(function () {
    return function () {
      // Run only on Unmount
      var _bodyComponent$curren2 = bodyComponent.current,
        scrollHeight = _bodyComponent$curren2.scrollHeight,
        scrollTop = _bodyComponent$curren2.scrollTop,
        clientHeight = _bodyComponent$curren2.clientHeight;
      getUpdateScrollState({
        scrollHeight: scrollHeight,
        scrollTop: scrollTop,
        clientHeight: clientHeight
      }, {
        itemType: itemType
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.tableContainer, " overflow-auto rt-table"),
    ref: bodyComponent
  }, children, !loading && scrollLoading && /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.spinnerWrapBottom, " full-width flex-center")
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: "medium"
  })), !allRowsLoaded && showLoadMore && /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.stickyBottom, " flex-center")
  }, __('Scroll to load more')));
};
BodyComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onAction: PropTypes.func.isRequired,
  itemType: PropTypes.string.isRequired,
  scrollLoading: PropTypes.bool,
  loading: PropTypes.bool,
  totalNumberOfEntries: PropTypes.number,
  minRows: PropTypes.number,
  scrollState: PropTypes.object
};
BodyComponent.defaultProps = {
  scrollLoading: false,
  loading: false,
  totalNumberOfEntries: 0,
  minRows: 0,
  scrollState: EMPTY_OBJECT
};
var mapDispatchToProps = {
  getUpdateScrollState: getUpdateScrollState
};
export default connect(null, mapDispatchToProps)(BodyComponent);